import { render } from "./CustomersDashboard.vue?vue&type=template&id=e4e5b2fa&scoped=true&lang=pug"
import script from "./CustomersDashboard.vue?vue&type=script&lang=js"
export * from "./CustomersDashboard.vue?vue&type=script&lang=js"

import "./CustomersDashboard.vue?vue&type=style&index=0&id=e4e5b2fa&lang=scss&scoped=true"
import "./CustomersDashboard.vue?vue&type=style&index=1&id=e4e5b2fa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4e5b2fa"]])

export default __exports__